import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import beautyBasketLogo from "@/assets/Beauty-basket-logo.webp";
import globeeLogo from "@/assets/globee-logo.webp";
import ojasLogo from "@/assets/Ojas-logo.webp";
import opulenttLogo from "@/assets/opulentt-logo.webp";
import winelamLogo from "@/assets/Winelam_cosmetics-Logo.webp";

const companies = [
  {
    name: "Beauty Basket",
    logo: beautyBasketLogo,
  },
  {
    name: "Globee",
    logo: globeeLogo,
  },
  {
    name: "Ojas",
    logo: ojasLogo,
  },
  {
    name: "Opulentt",
    logo: opulenttLogo,
  },
  {
    name: "Winelam",
    logo: winelamLogo,
  },
];

export default function TrustedBySection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 section-alt pointer-events-none" />
      <div className="container max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="section-title text-2xl lg:text-3xl mb-4">
            Trusted by <span className="text-gradient">innovative</span>  teams worldwide
          </h2>
          <p className="font-inter text-muted-foreground max-w-2xl mx-auto text-lg">
            Join the growing list of companies that trust us with their digital transformation
          </p>
        </motion.div>

        <div className="border border-border">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
            {companies.map((company, i) => (
              <motion.div
                key={company.name}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.3, delay: i * 0.05 }}
                className="flex flex-col items-center gap-2 p-3 sm:p-4 hover:bg-primary/5 transition-all duration-300 border-r border-b border-border"
              >
                <img
                  src={company.logo}
                  alt={`${company.name} logo`}
                  className="w-28 h-16 sm:w-28 sm:h-20 object-contain"
                  loading="lazy"
                  width="112"
                  height="80"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}